module.exports = __webpack_public_path__ + "static/logo-construction-schematics-dark-9311e31b4f11f770bfa065aaf20ac3d8.png";